"use client";

import dynamic from "next/dynamic";

import { useDeferredReady } from "./useDeferredReady";

// These are non-critical, always-mounted floating widgets. Code-splitting them
// out of the initial bundle (ssr: false) keeps the chatbot + Supabase realtime
// client and the marketing popup off the critical path, cutting initial
// JavaScript execution, main-thread work, and unused JS on every route.
const AIChatbot = dynamic(
  () => import("@/client/components/ai/chatbot").then((m) => m.AIChatbot),
  { ssr: false }
);

const LandingPopup = dynamic(
  () =>
    import("@/client/components/landing/natural-medicine-pathway").then(
      (m) => m.LandingPopup
    ),
  { ssr: false }
);

export function DeferredWidgets() {
  // Don't even fetch/execute these chunks until the browser is idle or the user
  // first interacts. supabase-js (pulled in by the chatbot) is the largest slice
  // of the "unused JavaScript" Lighthouse reports on first load, so keeping it
  // off the initial main thread cuts JS execution time, main-thread work, and
  // the number of long tasks.
  const ready = useDeferredReady();

  if (!ready) return null;

  return (
    <>
      <LandingPopup />
      <AIChatbot />
    </>
  );
}
